import { render } from "./WidgetContact.vue?vue&type=template&id=e3660524"
import script from "./WidgetContact.vue?vue&type=script&lang=js"
export * from "./WidgetContact.vue?vue&type=script&lang=js"

import "./WidgetContact.vue?vue&type=style&index=0&id=e3660524&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__